import { useNavigate } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import { Container, Row, Col, Table } from 'react-bootstrap';
import React, { useState, useEffect } from "react";
import ArrowBackIosNew from "@mui/icons-material/ArrowBackIosNew";
import "./pickUpDetails.css";
import { authKey,GET_CONSIGNMENT_DETAILS_BY_NUMBER,CONSIGNMENT_PICK_UP_SAVE, UPLOAD_DCUMENT} from '../../../common/URLs';

import { useLocation } from "react-router-dom";
import { ConfirmPopover } from '../../../preregcamps/confirmPopover/confirmPopover';
import { ErrorPopover } from '../../../common/ErrorPopover/errorPopover';
import { confirmAlert } from 'react-confirm-alert';
import { loaderService } from "../../../common/custom-loader/loader-service";
import { DialogContent, Dialog, DialogActions, Button } from '@mui/material';
import { viewdownloadDocument } from "../../../resource/screens/knowledgeManagement/knowledgeMangementApi";
import { getLocalStorageItem } from "../../../common/localStorageUtils";
import { PROD } from "../../../common/constants";
import { toast } from 'react-toastify';
import apiClient from "../../../axios";

function PickUpLotDetails(){

     const { state } = useLocation();
    //  console.log("pickup",state?.consignmentdetails?.acknowledgementId);

    //  console.log("consignmentdetails",state?.consignmentdetails)
    const navigate = useNavigate();
    const [showGrid, setShowGrid] = useState(false);
    const [pickupDetailsFormData, setPickupDetailsFormData] =useState()
    const [pickupDetailsSave, setPickupDetailsSave] = useState();
    const[pickupdetailsdata, setPickupdetailsdata] = useState();
    const[pickupdetailsSourcedata, setPickupdetailsSourcedata] = useState([]);
    const[pickupdetailsBundledata, setPickupdetailsBundledata] = useState();
    const[hideButtons, setHideButtons] = useState(false);
    const[consNo, setConsNo] = useState();
    const [documentUploadDetails, setDocumentUploadDetails] = useState();
    const [documentUploadDetailsForest, setDocumentUploadDetailsForest] = useState();
    const [selectedNocFile, setSelectedNocFile] = useState();
    const [selectedTransitFile, setSelectedTransitFile] = useState();
    const[lotDetails, setLotDetails] = useState(state?.growerItem?.consignmentPickupRbCbs);
    const[invoiceNo, setInvoiceNo] = useState(state?.growerItem?.invoiceNo);
    // const[totalWeightOfGrowers, setTotalWeightofGrowers] = useState(Number(state?.consignmentdetails?.consignmentSourceDetails?.reduce((accum,item) => Number(accum) + Number(item.totalWeight), 0)));
    // const [avgMoistureOfGrowers, setMoistureofGrowers] = useState(Number(state?.consignmentdetails?.consignmentSourceDetails?.reduce((accum,item) => Number(accum) + Number(item.totalMoisture), 0) / consignmentSourceDetails.length ));
    const [totalLotDetailsWeight,setTotalLotDetailsWeight] = useState(Number(state?.growerItem?.consignmentPickupRbCbs?.reduce((accum,item) => Number(accum) + Number(item.rbCbWeight), 0)));
    const [avgMoistureLotDetails,setAvgLotDetailsMoisture] = useState(Number(state?.growerItem?.consignmentPickupRbCbs?.reduce((accum,item) => Number(accum) + Number(item.avgMoisture), 0) / lotDetails.length));            
    const [lotDetailsArrNew, setLotDetailsArrNew] = useState([]);
    // delete state?.growerItem?.consignmentPickupRbCbs.inventoryDetails
    const[templotDetailsArr, setTempLotDetailsArr] = useState([]);
    const[completeLoading, setCompleteLoading] = useState();
    const [nocUploadDOc,setNocUploadDOc] = useState();
    const [transitPassUploadDOc,setTransitPassUploadDOc] = useState();
    const [logModalOpen, setLogModalOpen] = useState(false);
    const handleLogModalOpen = () => setLogModalOpen(true);
    const [logModalOpen1, setLogModalOpen1] = useState(false);
const handleLogModalOpen1 = () => setLogModalOpen1(true);
const handleLogModalClose1 = () => setLogModalOpen1(false);

const RBfileDownload = state?.growerItem;
console.log(state?.growerItem)


    const [pickupUpdatedDetails, setPickupUpdatedDetails] = useState({
      "isHitInspectionChecklist": state?.growerItem?.isHitInspectionChecklist,
      "isProperLashing": state?.growerItem?.isProperLashing,
      "isPayloadWithinCapacity": state?.growerItem?.isPayloadWithinCapacity,
      "isPayloadLengthExceedLimit": state?.growerItem?.isPayloadLengthExceedLimit,
      "isPayloadHeightExceedLimit": state?.growerItem?.isPayloadHeightExceedLimit,
      "odometerReading": state?.growerItem?.odometerReading,
      "nocFileId": state?.growerItem?.nocFileId,
      "nocFileName": state?.growerItem?.nocFileName,
      "transitPassFileId": state?.growerItem?.transitPassFileId,
      "transitFileName": state?.growerItem?.transitFileName,
      "containerName": state?.growerItem?.containerName,
      "acknowledgementId": state?.growerItem?.acknowledgementId
     })
     const[totalGrower, setTotalGrower] = useState([]);

  
     const radioChange = (e, value) => {
      setPickupUpdatedDetails({ ...pickupUpdatedDetails, [e.target.name]: value,
      })
      
      if (e.target.name === "isHitInspectionChecklist") 
      {
        setErrorMessage({ ...errorMessage, isHitInspectionChecklistError: "" });
      }
      if (e.target.name === "isProperLashing") 
      {
        setErrorMessage({ ...errorMessage, isProperLashingError: "" });
      }
      if (e.target.name === "isPayloadWithinCapacity") 
      {
        setErrorMessage({ ...errorMessage, isPayloadWithinCapacityError: "" });
      }
      if (e.target.name === "isPayloadLengthExceedLimit") 
      {
        setErrorMessage({ ...errorMessage, isPayloadLengthExceedLimitError: "" });
      }
      if (e.target.name === "isPayloadHeightExceedLimit") 
      {
        setErrorMessage({ ...errorMessage, isPayloadHeightExceedLimitError: "" });
      }
     
  };
    const[lotDetailsData, setLotDetailsData] = useState({
      "consignmentSourceDetailId": state?.growerItem?.id,
      "rbCbWeight":"",
      "avgMoisture":"",
      "speciesType":"",
      "noOfPoles":"",
      "barcodeNo":"",
      "bundleId": null,
      "isACtive": 1,
      
    })

    const [errorMessage, setErrorMessage] = useState({ 
      rbCbWeightError: "",
      avgMoistureError:"",
      barcodeNoError:"",  
      speciesTypeError:"",
      noOfPolesError:"",
      isHitInspectionChecklistError: "",
      isProperLashingError: "",
      isPayloadWithinCapacityError: "",
      isPayloadLengthExceedLimitError: "",
      isPayloadHeightExceedLimitError: "",
      odometerReadingError: '',
      lotDetailsError:"",

    });
    useEffect(() => {
      if (selectedNocFile) {
        getUploadNocFileDetails();
      }
    }, [selectedNocFile]);
    
    useEffect(() => {
      if (selectedTransitFile) {
        getUploadTransitPassFileDetails();
      }
    }, [selectedTransitFile]);

    
    // console.log("hhhhhoc", state?.consignmentdetails?.acknowledgementId)
    console.log("transit", transitPassUploadDOc?.blobResponse?.blobFileName)

    function getUploadNocFileDetails() {
      // loaderService.showLoader();
      const formData = new FormData();
      formData.append("file", selectedNocFile);
      formData.append("fileName", selectedNocFile.name);
      formData.append("containerName", "pit");
      apiClient
        .post(UPLOAD_DCUMENT, formData, {
          headers: {
            AuthKey: authKey,
          },
        })
        .then((response) => {
          setNocUploadDOc(response.data);
          // loaderService.hideLoader();
        })
  
        .catch(function (error) {
          console.log(error);
          // loaderService.hideLoader();
          toast.error(error.message);
        });
    }
    function getUploadTransitPassFileDetails() {
      // loaderService.showLoader();
      const formData = new FormData();
      formData.append("file", selectedTransitFile);
      formData.append("fileName", selectedTransitFile.name);
      formData.append("containerName", "pit");
      apiClient
        .post(UPLOAD_DCUMENT, formData, {
          headers: {
            AuthKey: authKey,
          },
        })
        .then((response) => {
          setTransitPassUploadDOc(response.data);
          // loaderService.hideLoader();
        })
  
        .catch(function (error) {
          console.log(error);
          // loaderService.hideLoader();
          toast.error(error.message);
        });
    }
    const viewAndDownloadDocument = (e, fileName, containerName, finalfileName) => {
      e.preventDefault();
      viewdownloadDocument(RBfileDownload?.nocFileId, RBfileDownload?.containerName, RBfileDownload?.nocFileName)
    }
    const viewAndDownloadDocumentForTransit = (e, fileName, containerName, finalfileName) => {
      e.preventDefault();
      viewdownloadDocument(RBfileDownload?.transitPassFileId, RBfileDownload?.containerName, RBfileDownload?.transitFileName)
    }



    const uploadNocDoc = (e, type) => {
      if (e.target.files[0].size >= 5000000) {
        setErrorMessage({
          ...errorMessage,
          nocFileIdError: "The file should be less than 5MB",
        });
      } else {
        setSelectedNocFile(e.target.files[0]);
        setPickupUpdatedDetails({...pickupUpdatedDetails, nocFileId: nocUploadDOc ? nocUploadDOc?.blobResponse?.blobFileName : RBfileDownload?.nocFileId, nocFileName: nocUploadDOc? nocUploadDOc?.blobResponse?.fileName : RBfileDownload?.nocFileName, containerName: "pit"})
        setErrorMessage({ ...errorMessage, nocFileIdError: " " });
      }
    };
    const uploadTransitPassDoc = (e, type) => {
      if (e.target.files[0].size >= 5000000) {
        setErrorMessage({
          ...errorMessage,
          transitPassFileIdError: "The file should be less than 5MB",
        });
      } else {
        setSelectedTransitFile(e.target.files[0]);
        setPickupUpdatedDetails({...pickupUpdatedDetails, transitPassFileId: transitPassUploadDOc ? transitPassUploadDOc?.blobResponse?.blobFileName : RBfileDownload?.transitPassFileId, transitFileName: transitPassUploadDOc? transitPassUploadDOc?.blobResponse?.fileName : RBfileDownload?.transitFileName, containerName: "pit"})
        setErrorMessage({ ...errorMessage, transitPassFileIdError: " " });
      }
    };
  // }
    // useEffect(() => {
    //   if (selectedFile) {
    //     getUploadDocumentDetails();
    //   }
    // }, [selectedFile]);
  
    // const uploadDocument = (e, type) => {
    //   if (e.target.files[0].size >= 5000000) {
    //     setErrorMessage({
    //       ...errorMessage,
    //       sponsoredDocumentError: "The file should be less than 5MB",
    //     });
    //   } else {
    //     setSelectedFile(e.target.files[0]);
    //     setErrorMessage({ ...errorMessage, sponsoredDocumentError: " " });
    //   }
    // };
    // const uploadDocumentForest = (e, type) => {
    //   if (e.target.files[0].size >= 5000000) {
    //     setErrorMessage({
    //       ...errorMessage,
    //       sponsoredDocumentError: "The file should be less than 5MB",
    //     });
    //   } else {
    //     setSelectedFileForest(e.target.files[0]);
    //     setErrorMessage({ ...errorMessage, sponsoredDocumentError: " " });
    //   }
    // };
  
    // function getUploadDocumentDetails() {
    //   loaderService.showLoader();
    //   const formData = new FormData();
    //   formData.append("file", selectedFile);
    //   formData.append("fileName", selectedFile.name);
    //   formData.append("containerName", "stakeholder");
    //   apiClient
    //     .post(UPLOAD_DCUMENT, formData, {
    //       headers: {
    //         AuthKey: authKey,
    //       },
    //     })
    //     .then((response) => {
    //       setDocumentUploadDetails(response.data);
    //       // setDocumentUploadDetailsForest(response.data);
    //       setPickupUpdatedDetails({...pickupUpdatedDetails, nocFileId: documentUploadDetails ? documentUploadDetails?.blobResponse?.blobFileName : pickupUpdatedDetails?.nocFileId, transitPassFileId: response.data.blobResponse.blobFileName})
    //       loaderService.hideLoader();
    //       // console.log("file upload",documentUploadDetails);
    //     })
  
    //     .catch(function (error) {
    //       console.log(error);
    //       loaderService.hideLoader();
    //     });
    // }
   
    // console.log("document", pickupUpdatedDetails)

    const handleChange = (e) => {
      if(e.target.name === "odometerReading") {
        setPickupUpdatedDetails({...pickupUpdatedDetails, [e.target.name]: e.target.value})
      }

      setLotDetailsData({
    
        ...lotDetailsData,
    
        [e.target.name]: e.target.value,
    
      });
      
    
      if (e.target.name === "rbCbWeight") 
      {
        setErrorMessage({ ...errorMessage, rbCbWeightError: "" });
      }
      if (e.target.name === "avgMoisture") 
      {
        setErrorMessage({ ...errorMessage, avgMoistureError: "" });
      }
      if (e.target.name === "barcodeNoError") 
      {
        setErrorMessage({ ...errorMessage, barcodeNoError: "" });
      }
      if (e.target.name === "speciesType") 
      {
        setErrorMessage({ ...errorMessage, speciesTypeError: "" });
      }
      if (e.target.name === "noOfPoles") 
      {
        setErrorMessage({ ...errorMessage, noOfPolesError: "" });
      }
      if (e.target.name === "odometerReading") 
      {
        setErrorMessage({ ...errorMessage, odometerReadingError: "" });
      }
      
    }
    // console.log("invoice",invoiceNo)
    // const onAddBundle = (e) => {
    //     e.preventDefault();
    //     setShowGrid(true);
    //     const tempArr = [...lotDetailsData]
    //     getPickupdetailsdataBundle();
    // }

    const onAddBundle = (e) => {
      e.preventDefault();
      setErrorMessage({ ...errorMessage, lotDetailsError: "" });
      if ((lotDetailsData.speciesType) && (lotDetailsData.avgMoisture) && (lotDetailsData.rbCbWeight) && (lotDetailsData.barcodeNo) && (lotDetailsData.noOfPoles)) {
        // setShowGrid(true);
        const tempArr = [...lotDetails]
        const tempArrNew = [...lotDetailsArrNew]
        //speciesDetailsArr.find(item => { return item.species === speciesDetails.species }) ? setErrorMessage({ ...errorMessage, sameSpeciesError: "Please add different species" }) :
          tempArr.push({
            ...lotDetailsData,
          });
       tempArrNew.push({...lotDetailsData})
          setLotDetails(tempArr);
          setLotDetailsArrNew(tempArrNew);
          setTotalLotDetailsWeight(Number(tempArr?.reduce((accum,item) => Number(accum) + Number(item.rbCbWeight), 0)))
          setAvgLotDetailsMoisture(Number(tempArr?.reduce((accum,item) => Number(accum) + Number(item.avgMoisture), 0 / lotDetails.length)))
          setLotDetailsData({
            "consignmentSourceDetailId": state?.growerItem?.id,
            "rbCbWeight":"",
            "avgMoisture":"",
            "speciesType":"",
            "noOfPoles":"",
            "barcodeNo":"",
            "bundleId": null,
            "isACtive": 1
      
          });
          document.getElementById("myForm").reset();
      }
      else {   
        if (!lotDetailsData?.barcodeNo) {
          setErrorMessage({ ...errorMessage, barcodeNoError: "Please Enter Barcode" });
        }
        if (!lotDetailsData?.noOfPoles) {
          setErrorMessage({ ...errorMessage, noOfPolesError: "Please Enter No of Poles" });
        }
        if (!lotDetailsData?.avgMoisture) {
          setErrorMessage({ ...errorMessage, avgMoistureError: "Please Enter Moisture" });
        }
        if (!lotDetailsData?.rbCbWeight) {
          setErrorMessage({ ...errorMessage, rbCbWeightError: "Please Enter Weight" });
        }
        if (!lotDetailsData?.speciesType) {
          setErrorMessage({ ...errorMessage, speciesTypeError: "Please Select Species" });
        }
      }
    }

useEffect(()=>{
  if(consNo)
  {
    getPickupdetailsdataBundle();
  }
  },[consNo]);
useEffect(() =>
 {
  setConsNo(state?.data?.consignmentNo);
 }, []);

    const getPickupdetailsdataBundle= () => {
      loaderService.showLoader()
      apiClient
        .post(GET_CONSIGNMENT_DETAILS_BY_NUMBER,
          {
            "consignmentNumber": consNo,
          },
          {
            headers: {
              Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
            }
          }, null
        )
        .then((response) => {
          // console.log("1",response);
          setLotDetails(response.data.consignmentSourceDetails[0].consignmentPickupRbCbs);
          setHideButtons(response.data.consignmentSourceDetails[0].invoiceNo!=null);
          setTotalGrower(response.data.consignmentSourceDetails);
          loaderService.hideLoader()
        })
        .catch(function (error) {
          console.log(error);
          loaderService.hideLoader()
          toast.error(error.message);
        });
    }
 
  const onSaveLotDetails = (e) =>
  {
    e.preventDefault();
    if(lotDetails.length>=0)
    {
      // setErrorMessage({ ...errorMessage, lotDetailsError: "" }); 
      pickupSave(false);
    }
    else
    {
      setErrorMessage({ ...errorMessage, lotDetailsError: "Please Add atleast one Lot" }); 
    }
  }


  const onLoadingDoneLotDetails = (e) =>
  {
    e.preventDefault();
    
    
  }
//  console.log("hii",!pickupUpdatedDetails.isHitInspectionChecklist);
    const pickupSave = (loadingDone) => {
      const totalWeightOfGrowers = Number(state?.consignmentdetails?.consignmentSourceDetails?.reduce((accum,item) => Number(accum) + Number(item.totalWeight), 0));
      const totalMoistureOfGrowers = Number(state?.consignmentdetails?.consignmentSourceDetails?.reduce((accum,item) => Number(accum) + Number(item.totalMoisture), 0) / state?.consignmentdetails?.consignmentSourceDetails?.length);
      // const totalLotDetailsWeight = Number(lotDetails?.reduce((accum,item) => Number(accum) + Number(item.rbCbWeight), 0));
      // const totalLotDetailsMoisture = Number(lotDetails?.reduce((accum,item) => Number(accum) + Number(item.avgMoisture), 0));
      // totalLotDetailsWeight = Number(state?.growerItem?.consignmentPickupRbCbs?.reduce((accum,item) => Number(accum) + Number(item.rbCbWeight), 0));
      // avgMoistureLotDetails = Number(state?.growerItem?.consignmentPickupRbCbs?.reduce((accum,item) => Number(accum) + Number(item.avgMoisture), 0) / lotDetails.length)

     
      // console.log("lotweight",totalLotDetailsMoisture);
      apiClient
          .post(CONSIGNMENT_PICK_UP_SAVE,   
            {

              "id": state?.consignmentdetails?.id,
            
              "consignmentNo": state?.consignmentdetails?.consignmentNo,
            
              "isLoadingCompleted": loadingDone,
            
              "totalWeight": totalWeightOfGrowers,
            
              // "totalMoisture": totalLotDetailsMoisture,
              "totalMoisture": totalMoistureOfGrowers,

              "consignmentSourceDetails": [
            
                {
            
                  "id": state?.growerItem?.id,
            
                  "consignmentId": state?.consignmentdetails?.id,
            
                  "weeklyScheduleNumber": state?.growerItem?.weeklyScheduleNumber,
            
                  "scheduleLineNumber": state?.growerItem?.scheduleLineNumber,
            
                  "consignmentStatus": state?.growerItem?.consignmentStatus,
            
                  // "consignmentPickupTimestamp": "2022-12-29T13:59:08.787Z",
            
                  "weightToBeLifted": state?.growerItem?.weightToBeLifted,
            
                  "sourceType": state?.growerItem?.sourceType,
            
                  "sourceStakeholderUrn": state?.growerItem?.sourceStakeholderUrn,
            
                  "sourceName": state?.growerItem?.sourceName,
            
                  "sourceLocationName": state?.growerItem?.sourceLocationName,
            
                  "sourceLocationAddress": state?.growerItem?.sourceLocationAddress,
            
                  "sourceStakeholderPo": state?.growerItem?.sourceStakeholderPo,
            
                  "odometerReading": pickupUpdatedDetails?.odometerReading,
            
                  "isHitInspectionChecklist": pickupUpdatedDetails?.isHitInspectionChecklist,
            
                  "isProperLashing": pickupUpdatedDetails?.isProperLashing,
            
                  "isPayloadWithinCapacity": pickupUpdatedDetails?.isPayloadWithinCapacity,
            
                  "isPayloadLengthExceedLimit": pickupUpdatedDetails?.isPayloadLengthExceedLimit,
            
                  "isPayloadHeightExceedLimit": pickupUpdatedDetails?.isPayloadHeightExceedLimit,  
                  "isSingleBundle": false,    
            
                  "totalWeight": totalLotDetailsWeight,
            
                  // "totalMoisture": totalLotDetailsMoisture,

                  "totalMoisture": avgMoistureLotDetails,

                  "containerName": pickupUpdatedDetails?.containerName,

                  "nocFileId": nocUploadDOc?.blobResponse?.blobFileName ? nocUploadDOc?.blobResponse?.blobFileName : pickupUpdatedDetails?.nocFileId,

                  "nocFileName": nocUploadDOc?.blobResponse?.fileName ? nocUploadDOc?.blobResponse?.fileName : pickupUpdatedDetails?.nocFileName,

                  "transitFileName": transitPassUploadDOc?.blobResponse?.fileName ? transitPassUploadDOc?.blobResponse?.fileName : pickupUpdatedDetails?.transitFileName,
            
                  "transitPassFileId": transitPassUploadDOc?.blobResponse?.blobFileName ? transitPassUploadDOc?.blobResponse?.blobFileName : pickupUpdatedDetails?.transitPassFileId,
            
                  "isSourceNotificationSent": state?.growerItem?.isSourceNotificationSent,
            
                  "isSourceNotificationAcklgd": state?.growerItem?.isSourceNotificationAcklgd,
            
                  "leftoverQuantity": state?.growerItem?.leftoverQuantity,
            
                  "isActive": 1,
            
                  // "createdOn": "2022-12-29T13:59:08.787Z",
            
                  // "createdBy": "7b146c20-1ba0-495f-88c2-5482a124f9c9",      
            
                  // "consignmentPickupRbCbs": !loadingDone ? lotDetailsArrNew : {},
                  // "consignmentPickupRbCbs": loadingDone ? lotDetailsArrNew : null,
                  "consignmentPickupRbCbs": lotDetailsArrNew            
                }
            
              ]
            
            },        
             
            {
              headers: {
                Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
              }
            }, null
          )
          .then((response) => {
            setLotDetailsArrNew([]);
            setPickupDetailsSave(response.data);
            
          })
          .catch(function (error) {
            setPickupDetailsSave(error);
           toast.error(error.message);

          });
      }


      const updateLot = (e,item,type)=>{
         item[type] = e.target.value;
         let lotList = [...lotDetails];
         lotList.forEach(i=>{
           if(i.bundleId === item.bundleId){
             i = item;
           }
         }) 
         setLotDetails(lotList)
      }

      const onSaveLot = ()=>{

       let growerItemData = state?.growerItem;
       growerItemData.consignmentPickupRbCbs = lotDetails;
       navigate("/lotDetails", { state: { growerItem: growerItemData,consignmentdetails: state?.consignmentdetails,consignmentNo: state?.consignmentdetails?.consignmentNo } });
      }

      //  useEffect(() => {
      //   if (completeLoading) {
      //     if (completeLoading.isSuccess === "true") {
      //       confirmAlert({
      //         customUI: ({ onClose }) => {
      //           return (
      //             <ErrorPopover
      //               title={completeLoading.message}
      //               onClose={onClose} hideLink={true}
      //             ></ErrorPopover> 
      //           );
      //         },
      //       });
      //     } 
      //     else {
      //       confirmAlert({
      //         customUI: ({ onClose }) => {
      //           return (
      //             <ConfirmPopover
      //               onClose={onClose}
      //               title={
      //                 completeLoading?.message
      //                   ? completeLoading?.message
      //                   : 
      //                 "Error"
      //               } hideLink={true}
      //             />
      //           );
      //         },
      //       });
      //     }
      //   }
      // }, [completeLoading]);

      useEffect(() => {
        if (pickupDetailsSave) {
          if (pickupDetailsSave.isSuccess === "true") {
            // confirmAlert({
            //   customUI: ({ onClose }) => {
            //     return (
            //       <ErrorPopover
            //         title={pickupDetailsSave.message}
            //         onClose={onClose} hideLink={true}
            //       ></ErrorPopover> 
            //     );
            //   },
            // });
            handleLogModalOpen1();
          } 
          else {
            // confirmAlert({
            //   customUI: ({ onClose }) => {
            //     return (
            //       <ConfirmPopover
            //         onClose={onClose}
            //         title={
            //           pickupDetailsSave?.message
            //             ? pickupDetailsSave?.message
            //             : 
            //           "Error"
            //         } hideLink={true}
            //       />
            //     );
            //   },
            // });
            handleLogModalOpen();
          }
        }
      }, [pickupDetailsSave]);
      // console.log("ac", acknowledgementId)
    
      return(
        <div>
            <Container fluid>
                <Row>
                    {/* <Col xs={12} md={3} className='common-internal-sidebar-col'>
                        <div className="common-internal-sidebar-container-pickupdetails">
                            <ArrowBackIosNew className="arrow-icon" onClick={() => (navigate("/consignmentPickUp", { state: { consignmentNo:  state?.consignmentdetails?.consignmentNo }}))} />
                        </div>
                    </Col> */}
                    <Col xs={12} md={12}>
                    {!PROD &&      <p style={{textAlign:"center", fontSize:"2vh"}}>PIT05</p> }
                        <form id="myForm">
                        <p className='headingStylePIT' style={{marginLeft: "1vw"}}>Pick-Up Details</p>
                            <div>
                               <Container fluid>
                                  <Row>
                                    <p className='pickupdeatils-heading'>Lot Details</p>
                                    <Container fluid>
                                      <Row>
                                      {lotDetails.length !== 0 ?

                                       <Col xs={12} md={12}>
                                        
                                            <div className='pickup-details-table-div'>
                                                <Table responsive className="common-table" striped>
                                                    <thead>
                                                            <tr>
                                                            <th className='common-table-heading-text'>Bundle ID</th>
                                                                <th className='common-table-heading-text'>Species Type</th>
                                                                <th className='common-table-heading-text'>Weight(in MT)</th>
                                                                <th className='common-table-heading-text'>Average Moisture</th>
                                                                <th className='common-table-heading-text'>No of poles</th>
                                                                <th className='common-table-heading-text'>Barcode</th>
                                                            </tr>
                                                    </thead>
                                                    <tbody>
                                                    {lotDetails && lotDetails?.map((item, index) => (
                                                            <tr key={index}>
                                                               <td className='common-table-text'>{item.bundleId}</td>
                                                                <td className='common-table-text'><input type="text" size="15" onChange={(e)=>{updateLot(e,item,"speciesType")}} value={item.speciesType}/></td>
                                                                <td className='common-table-text'><input type="text" size="10"  onChange={(e)=>{updateLot(e,item,"rbCbWeight")}}  value={item.rbCbWeight}/></td>
                                                                <td className='common-table-text'><input type="text"  size="10" onChange={(e)=>{updateLot(e,item,"avgMoisture")}}  value={item.avgMoisture}/></td>
                                                                <td className='common-table-text'><input type="text"  size="10" onChange={(e)=>{updateLot(e,item,"noOfPoles")}}  value={item.noOfPoles}/></td>
                                                                <td className='common-table-text'><input type="text"  size="10" onChange={(e)=>{updateLot(e,item,"barcodeNo")}}  value={item.barcodeNo}/></td>
                                                            </tr>
                                                     ) )}    
                                                    </tbody>
                                                </Table>
                                            </div>
                                       
                                    </Col>
                                    : null } 
                                  </Row>
                               </Container>
                            
                                  </Row>
                               </Container>
       
                               {/* <Row>
                                <Col xs={12} md={2} col={12}>    
                                    <button className='submit-btn-RB' type='submit'>Save</button>
                                </Col>
                                <Col xs={12} md={2} col={12}>    
                                    <button className='submit-btn-RB-1' type='submit'>Complete Loading</button>
                                </Col>
                              </Row> */}
                              <Row>
                              
                                 <Col xs={12} md={12}>
                                  {lotDetails.length !== 0 &&
                                       <button className="nextBtn_consignment_complete"  onClick={(e)=>onSaveLot(e)}>Save</button>
                                  }
                                 </Col>
                            
                              </Row>
                             
                            </div>
                        </form>
                    </Col>
                </Row>
            </Container>
            <Dialog maxWidth='xs' fullWidth open={logModalOpen}>
                <DialogContent>
                <ConfirmPopover title={pickupDetailsSave?.message} navigate={navigate} gotoConsignmentPickup="gotoConsignmentPickup"/>
                </DialogContent>
            </Dialog>
            <Dialog maxWidth='xs' fullWidth open={logModalOpen1}>
        <DialogContent>
          <ErrorPopover title={pickupDetailsSave?.message ? pickupDetailsSave?.message : "Error" }/>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleLogModalClose1}>OK</Button>
        </DialogActions>
      </Dialog>
        </div>
    )
}
export default PickUpLotDetails;